import { faPlusCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ShareFat } from '@phosphor-icons/react'
import { isBefore, parseISO, startOfDay } from 'date-fns'
import { useCallback, useEffect, useState } from 'react'
import { Button, Card, Container, Form, Modal } from 'react-bootstrap'
import { CheckCircle } from 'react-bootstrap-icons'
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import swal from 'sweetalert'
import AutocompleteClienteDefault from '../../components/autocomplete-cliente/autocomplete-clienteDefault'
import { CustomButton } from '../../components/CustomButton'
import { CustomPriceInput } from '../../components/CustomPriceInput'
import Navbar from '../../components/navbar/navbar'
import apinode from '../../services/api'
import { adaptValue } from '../../utils/adaptValue'
import { sendErrorApiMessage } from '../../utils/sendErrorApiMessage'
import '../pedido-editar/pedido-editar.css'
import './contas-editar.css'

function EditarContas() {
  const [id, setId] = useState('')
  const { idConta } = useParams()
  const [idFornecedor, setIdFornecedor] = useState('')
  const [formaDePgto, setFormaDePgto] = useState('')
  const [numeroIdent, setNumeroIdent] = useState('')
  const [numeroDoc, setNumeroDoc] = useState('')
  const [vencimento, setVencimento] = useState('')
  const [valor, setValor] = useState('')
  const [situacao, setSituacao] = useState('Em Aberto')
  const [vencimentoOriginal, setVencimentoOriginal] = useState('')
  const [dataEmissao, setDataEmissao] = useState('')
  const [competencia, setCompetencia] = useState('')
  const [portador, setPortador] = useState('')
  const [categoria, setCategoria] = useState('')
  const [historicoConta, setHistoricoConta] = useState('')
  const [dataPgto, setDataPgto] = useState('')
  const [subCategoria, setSubCategoria] = useState('')
  const [idNfeEntrada, setIdNfeEntrada] = useState('')
  const [idPedidoCompra, setIdPedidoCompra] = useState('')
  const [pesRazao, setPesRazao] = useState('')
  const [pesCpf, setPesCPf] = useState('')
  const [pago, setPago] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [razaoSocial, setRazaoSocial] = useState('')
  const [cpfCnpj, setCpfCnpj] = useState('')
  const [categoriaOptions, setCategoriaOptions] = useState([])
  const [recorrencia, setRecorrencia] = useState('UNICA')
  const [recorrenciaVencimento, setRecorrenciaVencimento] = useState('')
  const [recorrenciaLimite, setRecorrenciaLimite] = useState('')
  const [isSendAccountLoading, setIsSendAccountLoading] = useState(false)

  const conta = localStorage.idconta
  const navigate = useNavigate()

  function handleKeyDown(event, campoAtual) {
    if (event.keyCode === 13) {
      event.preventDefault()
      // Faça alguma ação aqui com o valor do campoAtual
      // Por exemplo, envie o valor para o servidor ou faça alguma validação
      console.log(`Campo ${campoAtual}: ${event.target.value}`)
    }
  }

  useEffect(() => {
    const fetchCategoriaOptions = async () => {
      try {
        const response = await apinode.get(
          `/contas/categoria/${localStorage.idconta}`,
        )

        setCategoriaOptions(response.data)
      } catch (err) {
        sendErrorApiMessage(err, 'Erro ao listar as categorias')
      }
    }

    fetchCategoriaOptions()
  }, [])

  const formatCpfCnpj = (value) => {
    if (!value) return ''

    const numbersOnly = value.replace(/[^\d]/g, '')

    if (numbersOnly.length <= 11) {
      return numbersOnly.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
    } else {
      return numbersOnly.replace(
        /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
        '$1.$2.$3/$4-$5',
      )
    }
  }

  const handleNomeCliente = (nome) => {
    setPesRazao(nome)
    // Atualize o campo PES_RAZAO em editedConta com o nome do cliente selecionado
  }

  const handleOpenModal = (e) => {
    e.preventDefault()

    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    // e.preventDefault();

    setIsModalOpen(false)
  }

  const handleIdCliente = (id) => {
    setIdFornecedor(id)
  }

  const handleCpf = (cpf) => {
    setPesCPf(cpf)
  }

  const SalvarCliente = () => {
    const dados = {
      PES_RAZAO: razaoSocial,
      PES_CNPJ_CPF: cpfCnpj,
    }

    apinode
      .post(`/contas/addcliente/${conta}`, dados)
      .then((response) => {
        console.log(response.data)
        swal('Sucesso', response.data.retorno, 'success')
      })
      .catch((error) => {
        console.error(error)
        swal('Erro', error.response.data.retorno, 'warning')
        // Handle the error appropriately here
      })
  }

  const handleBaixarConta = () => {
    const desejaBaixar = window.confirm('Deseja baixar as contas selecionadas?')

    if (desejaBaixar) {
      apinode
        .put(`/contas/pgconta/${conta}?ids=${idConta}`, {})
        .then((response) => {
          console.log(response.data)
          swal('Sucesso', response.data.retorno, 'success')
          listarContas()
        })
        .catch((error) => {
          console.error(error)
          swal('Erro', error.response.data.retorno, 'warning')
          // Handle the error appropriately here
        })
    } else {
      // Handle if the user clicks "Cancel" or closes the dialog without confirming
      // For example, you can show a message or perform other actions.
    }
  }

  async function enviarConta() {
    const dados = {
      ID_FORNCEDOR: idFornecedor,
      FORMA_DE_PGTO: formaDePgto,
      NUMERO_IDENT: numeroIdent,
      NUMERO_DOC: numeroDoc,
      VENCIMENTO: vencimento,
      VALOR: adaptValue(valor),
      SITUACAO: situacao,
      VENCIMENTO_ORIGINAL: vencimentoOriginal,
      DATA_EMISSAO: dataEmissao,
      COMPETENCIA: competencia,
      PORTADOR: portador,
      CATEGORIA: categoria,
      HISTORICO_CONTA: historicoConta,
      SUB_CATEGORIA: subCategoria,
      IDNFEENTRADA: idNfeEntrada || null,
      IDPEDIDOCOMPRA: idPedidoCompra || null,
      RECORRENCIA: recorrencia,
      RECORRENCIA_VENCIMENTO: recorrenciaVencimento,
      RECORRENCIA_LIMITE: recorrenciaLimite,
    }

    try {
      setIsSendAccountLoading(true)

      if (idConta) {
        await apinode.put(
          `/contas/updateconta/${localStorage.idconta}/${idConta}`,
          dados,
        )
      } else {
        await apinode.post(`/contas/addconta/${localStorage.idconta}`, dados)
      }

      toast.success('Contas enviadas com sucesso!')
      navigate('/contasapagar')
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao enviar conta')
    } finally {
      setIsSendAccountLoading(false)
    }
  }

  function formatarData(data) {
    if (!data) return null // Trata o caso em que data é null
    const dataObj = new Date(data)
    const ano = dataObj.getFullYear()
    const mes = String(dataObj.getMonth() + 1).padStart(2, '0')
    const dia = String(dataObj.getDate()).padStart(2, '0')
    return `${ano}-${mes}-${dia}`
  }

  const listarContas = useCallback(async () => {
    try {
      const response = await apinode.get(
        `/contas/contapagar/${idConta}/${localStorage.idconta}`,
      )

      console.log(response.data)

      setId(response.data.ID)
      setIdFornecedor(response.data.ID_FORNCEDOR)
      setPesRazao(response.data.PES_RAZAO)
      setFormaDePgto(response.data.FORMA_DE_PGTO)
      setNumeroIdent(response.data.NUMERO_IDENT)
      setNumeroDoc(response.data.NUMERO_DOC)
      setVencimento(formatarData(response.data.VENCIMENTO))
      setSituacao(response.data.SITUACAO)
      setVencimentoOriginal(formatarData(response.data.VENCIMENTO_ORIGINAL))
      setDataEmissao(formatarData(response.data.DATA_EMISSAO))
      setCompetencia(formatarData(response.data.COMPETENCIA))
      setPortador(response.data.PORTADOR)
      setCategoria(response.data.CATEGORIA)
      setHistoricoConta(response.data.HISTORICO_CONTA)
      setIdNfeEntrada(response.data.IDNFEENTRADA)
      setIdPedidoCompra(response.data.IDPEDIDOCOMPRA)
      setPesRazao(response.data.PES_RAZAO)
      setPesCPf(response.data.PES_CNPJ_CPF)
      setDataPgto(formatarData(response.data.DATA_PGTO))
      setValor(response.data.VALOR)
      setRecorrencia(response.data.RECORRENCIA)
      setRecorrenciaVencimento(response.data.RECORRENCIA_VENCIMENTO)
      setRecorrenciaLimite(formatarData(response.data.RECORRENCIA_LIMITE))

      if (response.data.SITUACAO === 'Pago') {
        setPago(true)
      }
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao buscar conta')
    }
  }, [idConta])

  useEffect(() => {
    if (idConta) {
      listarContas()
    }
  }, [idConta, listarContas])

  return (
    <>
      <Navbar />

      <Container
        className="mt-page"
        style={{
          display: 'flex',
          justifyContent: 'center',
          height: 'auto',
          minHeight: '100vh',
        }}
      >
        <Card
          style={{
            width: '50%',
          }}
        >
          <Card.Body>
            <div
              className="mb-4 mt-2"
              style={{ flex: 1 }}
            >
              <div className="mb-4 mt-2 text-left">
                <h3>
                  <span className="text-primary h5">{pesRazao}</span>{' '}
                  {pago && (
                    <CheckCircle
                      className="text-success ms-2"
                      size={40}
                    />
                  )}
                </h3>
                <p className="text-muted mb-0 ">{pesCpf}</p>
              </div>

              <form>
                <div className="col-md-12 mb-3">
                  <label
                    htmlFor="CLIENTE"
                    className="form-label"
                  >
                    Cliente:
                  </label>

                  <AutocompleteClienteDefault
                    placeholder="Pesquisar cliente..."
                    onClickNome={handleNomeCliente}
                    onClickId={handleIdCliente}
                    onClickCpf={handleCpf}
                    value={pesRazao} // Passa o nome do cliente selecionado ao componente
                    className="form-control"
                  />
                </div>

                <div className="col-md-12 mb-3">
                  <button
                    className="btn btn-outline-secondary"
                    onClick={handleOpenModal}
                  >
                    <FontAwesomeIcon icon={faPlusCircle} /> Add. Cliente
                  </button>
                </div>

                <div className="row mb-3">
                  <div className="col-md-4">
                    <label>ID</label>
                    <input
                      disabled
                      type="text"
                      className="form-control"
                      value={id}
                      onChange={(e) => setId(e.target.value)}
                      onKeyDown={(e) => handleKeyDown(e, 'Campo 1')}
                    />
                  </div>
                  <div className="col-md-4">
                    <label>Cod. Forncedor</label>
                    <input
                      type="text"
                      className="form-control"
                      value={idFornecedor}
                      onChange={(e) => setIdFornecedor(e.target.value)}
                      onKeyDown={(e) => handleKeyDown(e, 'Campo 1')}
                    />
                  </div>
                  <div className="col-md-4">
                    <label>Forma de Pgto</label>
                    <select
                      className="form-control"
                      style={{ border: '1px solid #ccc' }}
                      value={formaDePgto}
                      onChange={(e) => setFormaDePgto(e.target.value)}
                      onKeyDown={(e) => handleKeyDown(e, 'Campo 1')}
                    >
                      <option value="">Não selecionado</option>{' '}
                      {/* Opção adicionada */}
                      <option value="cartao_credito">Cartão de Crédito</option>
                      <option value="cartao_debito">Cartão de Débito</option>
                      <option value="Boleto">Boleto Bancário</option>
                      <option value="transferencia">
                        Transferência Bancária
                      </option>
                      <option value="Dinheiro">Dinheiro</option>
                      <option value="cheque">Cheque</option>
                      <option value="pix">Pix</option>
                    </select>
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-4">
                    <label>Nº Indentificação</label>
                    <input
                      type="text"
                      className="form-control"
                      value={numeroIdent}
                      onChange={(e) => setNumeroIdent(e.target.value)}
                      onKeyDown={(e) => handleKeyDown(e, 'Campo 1')}
                    />
                  </div>
                  <div className="col-md-4">
                    <label>Nº Documento</label>
                    <input
                      type="text"
                      className="form-control"
                      value={numeroDoc}
                      onChange={(e) => setNumeroDoc(e.target.value)}
                      onKeyDown={(e) => handleKeyDown(e, 'Campo 1')}
                    />
                  </div>

                  <div className="col-md-4">
                    <label>Vencimento</label>
                    <input
                      type="date"
                      className="form-control"
                      value={vencimento}
                      onChange={(e) => setVencimento(e.target.value)}
                      onKeyDown={(e) => handleKeyDown(e, 'Campo 1')}
                      min={formatarData(new Date())}
                    />
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-4">
                    <Form.Label>Recorrência</Form.Label>

                    <Form.Select
                      value={recorrencia}
                      disabled={idConta}
                      onChange={(e) => {
                        setRecorrencia(e.target.value)

                        if (e.target.value === 'UNICA') {
                          setRecorrenciaVencimento('')
                          setRecorrenciaLimite('')
                        }
                      }}
                    >
                      <option value="UNICA">Única</option>
                      <option value="MENSAL">Mensal</option>
                    </Form.Select>
                  </div>

                  <div className="col-md-4">
                    <Form.Label>Dia de vencimento</Form.Label>

                    <Form.Control
                      value={recorrenciaVencimento}
                      disabled={recorrencia === 'UNICA' || idConta}
                      onChange={(e) => setRecorrenciaVencimento(e.target.value)}
                    />
                  </div>

                  <div className="col-md-4">
                    <Form.Label>Data limite</Form.Label>

                    <Form.Control
                      type="date"
                      value={recorrenciaLimite}
                      onChange={(e) => setRecorrenciaLimite(e.target.value)}
                      disabled={recorrencia === 'UNICA' || idConta}
                    />
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-4">
                    <label>Valor</label>

                    <CustomPriceInput
                      value={valor}
                      onChange={(e) => setValor(e.target.value)}
                    />
                  </div>
                  <div className="col-md-4">
                    <label>Situação</label>
                    <select
                      className="form-control"
                      style={{ border: '1px solid #ccc' }}
                      value={situacao}
                      onChange={(e) => setSituacao(e.target.value)}
                    >
                      <option value="-1">--Não Selecionado--</option>
                      <option value="Em Aberto">Em Aberto</option>
                      <option value="Pago">Pago</option>
                      <option value="Aguardando Pagamento">
                        Aguardando Pagamento
                      </option>
                      <option value="Vencida">Vencida</option>
                      <option value="Cartorio">Cartorio</option>
                    </select>
                  </div>

                  <div className="col-md-4">
                    <label>Venc. original</label>
                    <input
                      type="date"
                      className="form-control"
                      value={vencimentoOriginal}
                      onChange={(e) => setVencimentoOriginal(e.target.value)}
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-4">
                    <label>Emissao em:</label>
                    <input
                      type="date"
                      className="form-control"
                      value={dataEmissao}
                      onChange={(e) => setDataEmissao(e.target.value)}
                      onKeyDown={(e) => handleKeyDown(e, 'Campo 1')}
                    />
                  </div>
                  <div className="col-md-4">
                    <label>Competencia</label>
                    <input
                      type="date"
                      className="form-control"
                      value={competencia}
                      onChange={(e) => setCompetencia(e.target.value)}
                      onKeyDown={(e) => handleKeyDown(e, 'Campo 1')}
                    />
                  </div>
                  <div className="col-md-4">
                    <label>Portador</label>
                    <input
                      type="text"
                      className="form-control"
                      value={portador}
                      onChange={(e) => setPortador(e.target.value)}
                      onKeyDown={(e) => handleKeyDown(e, 'Campo 1')}
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-4">
                    <label>Categoria</label>
                    <select
                      className="form-control"
                      value={categoria}
                      onChange={(e) => setCategoria(e.target.value)}
                      onKeyDown={(e) => handleKeyDown(e, 'Campo 1')}
                    >
                      <option value="">Selecione...</option>
                      {categoriaOptions.map((option, index) => (
                        <option
                          key={index}
                          value={option.CODIGO}
                        >
                          {option.DESCRICAO}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-12">
                    <label>Obs</label>
                    <textarea
                      rows="5"
                      type="text"
                      className="form-control"
                      value={historicoConta}
                      onChange={(e) => setHistoricoConta(e.target.value)}
                      onKeyDown={(e) => handleKeyDown(e, 'Campo 1')}
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-4">
                    <label>Pago em:</label>
                    <input
                      type="date"
                      className="form-control"
                      value={dataPgto}
                      onChange={(e) => setDataPgto(e.target.value)}
                      onKeyDown={(e) => handleKeyDown(e, 'Campo 1')}
                    />
                  </div>
                  <div className="col-md-4">
                    <label>Sub Categoria</label>
                    <input
                      type="text"
                      className="form-control"
                      value={subCategoria}
                      onChange={(e) => setSubCategoria(e.target.value)}
                      onKeyDown={(e) => handleKeyDown(e, 'Campo 1')}
                    />
                  </div>
                  <div className="col-md-4">
                    <label>Nfe</label>
                    <input
                      type="text"
                      className="form-control"
                      value={idNfeEntrada}
                      onChange={(e) => setIdNfeEntrada(e.target.value)}
                      onKeyDown={(e) => handleKeyDown(e, 'Campo 1')}
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-4">
                    <label>Pedido Compra</label>
                    <input
                      type="text"
                      className="form-control"
                      value={idPedidoCompra}
                      onChange={(e) => setIdPedidoCompra(e.target.value)}
                      onKeyDown={(e) => handleKeyDown(e, 'Campo 1')}
                    />
                  </div>
                  {/* Adicione outros campos aqui, se necessário */}
                </div>

                <div className="d-grid">
                  <CustomButton
                    isLoading={isSendAccountLoading}
                    title="Enviar"
                    isLoadingText="Enviando..."
                    onClick={enviarConta}
                    isDisabled={
                      recorrencia === 'MENSAL' &&
                      (!vencimento ||
                        !recorrenciaVencimento ||
                        !recorrenciaLimite)
                    }
                  >
                    <ShareFat
                      size={20}
                      weight="fill"
                    />
                  </CustomButton>
                </div>
              </form>

              <div className="mt-4 d-flex justify-content-between">
                <button
                  type="button"
                  className="btn btn-secondary mx-2"
                  onClick={handleBaixarConta}
                >
                  <i className="bi bi-download"></i> Baixar Conta
                </button>
                <button
                  type="button"
                  className="btn btn-secondary mx-2"
                >
                  <i className="bi bi-printer"></i> Imprimir Recibo
                </button>
                <button
                  type="button"
                  className="btn btn-secondary mx-2"
                >
                  <i className="bi bi-gear"></i> Alterar Andamento
                </button>
                <button
                  type="button"
                  className="btn btn-secondary mx-2"
                >
                  <i className="bi bi-pencil"></i> Adicionar Observações
                </button>
              </div>
            </div>
          </Card.Body>
        </Card>
      </Container>

      <Modal
        show={isModalOpen}
        onHide={handleCloseModal}
      >
        <Modal.Header closeButton>
          <Modal.Title>Cadastrar Cliente</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <label className="form-label">CPF/CNPJ</label>
            <input
              type="text"
              className="form-control"
              value={formatCpfCnpj(cpfCnpj)} // Aplicar a máscara aqui
              onChange={(e) => setCpfCnpj(e.target.value)}
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Razão Social</label>
            <input
              type="text"
              className="form-control"
              value={razaoSocial}
              onChange={(e) => setRazaoSocial(e.target.value)}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleCloseModal}
          >
            Fechar
          </Button>
          <Button
            variant="primary"
            onClick={SalvarCliente}
          >
            Salvar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default EditarContas
